import { DEFAULT_TINYMCE_OPTIONS } from '../../../../shared/default-tinymce-options';

export const FOD_EXTRA_CONTENT_MESSAGE_TINYMCE_OPTIONS = {
    ...DEFAULT_TINYMCE_OPTIONS,

    selector: '#tinyMceExtraContentMessage',
    content_css: '/assets/css/fod-default-tinymce.css',
    height: '200px',

    plugins: [
        'searchreplace'
    ],

    toolbar1: 'searchreplace | undo redo | vForm',
    //toolbar1: 'fontsizeinput | searchreplace | code fullscreen',
    //toolbar1: 'blocks fontsizeinput | outdent indent | searchreplace | charmap subscript superscript | removeformat',
    //toolbar2: 'bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | table | undo redo | visualchars visualblocks | code fullscreen',
    //toolbar3: 'pdfPreview | vPessoas vLocais vDatas vForm',

    addDynamicMenu: editor => { },

    setup: editor => {
        FOD_EXTRA_CONTENT_MESSAGE_TINYMCE_OPTIONS.addDynamicMenu(editor);
    }
};

export const FOD_EXTRA_CONTENT_WAITING_MESSAGE_TINYMCE_OPTIONS = {
    ...DEFAULT_TINYMCE_OPTIONS,

    selector: '#tinyMceExtraContentWaitingMessage',
    content_css: '/assets/css/fod-default-tinymce.css',
    height: '200px',

    plugins: [
        'searchreplace'
    ],

    toolbar1: 'searchreplace | undo redo | vForm',
    //toolbar1: 'fontsizeinput | searchreplace | code fullscreen',
    //toolbar1: 'blocks fontsizeinput | outdent indent | searchreplace | charmap subscript superscript | removeformat',
    //toolbar2: 'bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | table | undo redo | visualchars visualblocks | code fullscreen',
    //toolbar3: 'pdfPreview | vPessoas vLocais vDatas vForm',

    addDynamicMenu: editor => { },

    setup: editor => {
        FOD_EXTRA_CONTENT_WAITING_MESSAGE_TINYMCE_OPTIONS.addDynamicMenu(editor);
    }
};
